import {getRoot, types} from 'mobx-state-tree';
import EventModel from '../models/event-model';
import DeviceModel from '../models/device-model';
import PositionModel from '../models/position-model';
import config from '../config';

const EventStore = types
    .model('EventStore', {
        list: types.maybe(types.array(EventModel)),
        current: types.maybeNull(
            types.union(
                types.late(() => EventModel),
                types.reference(types.late(() => EventModel)),
            ),
        ),
        position: types.maybeNull(PositionModel),
        currentDevice: types.maybeNull(
            types.safeReference(DeviceModel),
        ),
        positionBuffer: types.optional(types.array(PositionModel), []),
        enabledSound: types.optional(types.boolean, true),
    })
    .actions((self) => ({
        add: (event) =>
            (self.list = [...self.list.slice(0, config.eventLimit - 1), event]),
        removeAll: (_) => (self.list = []),
        // O id chega como texto quando vem da URL e como numero quando vem do store. Comparando sem
        // normalizar, `findIndex` devolvia -1 e `splice(-1, 1)` apagava o ultimo da lista -- sempre
        // a notificacao errada.
        remove: (id) => {
            const idx = self.list.findIndex((e) => String(e.id) === String(id));
            if (idx >= 0) self.list.splice(idx, 1);
        },
        setCurrent: (event) => (self.current = event),
        setCurrentDevice: (device) => (self.currentDevice = device),
        setBuffer: (positions) => (self.positionBuffer = positions),
        setPosition: (position) => (self.position = position),
        setEnableSound: (enable) => (self.enabledSound = enable),
    }))
    .views((self) => ({
        // O nome do dispositivo e gravado no evento no instante em que ele chega, entao evento que
        // chega antes de a frota carregar fica com o nome vazio para sempre. Resolver aqui, na
        // leitura, faz o nome aparecer assim que a frota entra -- e vale para todas as telas que
        // consomem a lista, nao so a que se lembrou de tratar.
        get toList() {
            const raiz = getRoot(self);
            const porId = raiz && raiz.devices ? raiz.devices.devicesMap : null;

            return self.list.toJSON().map((evento) => {
                if (evento.name || !porId) return evento;

                const dispositivo = porId.get(evento.deviceId);
                return dispositivo ? {...evento, name: dispositivo.name} : evento;
            });
        },
        getEnabledSound() {
            return self.enabledSound;
        },
        get isSoundEnabled() {
            return self.enabledSound;
        },
        findById: (id) => self.list.find((e) => String(e.id) === String(id)),
    }));

export default EventStore;
